import type { ApiClientKind } from '@/api/client'
import type { Ga4TrafficQuery } from '@/api/types'

/** The connection's health, read by Integrations › Google Analytics. */
export const ga4Keys = {
  all: ['ga4-integration'] as const,
  integration: (kind: ApiClientKind) => ['ga4-integration', kind] as const,
}

/** The React Query keys the Traffic page reads; Integrations invalidates `all` after a connect or import. Neither feature imports the other: both import this. */
export const trafficKeys = {
  all: ['ga4-traffic'] as const,
  report: (kind: ApiClientKind, query: Ga4TrafficQuery) => ['ga4-traffic', kind, query] as const,
}
